import { render, staticRenderFns } from "./GJgrowEventCreateQuestionSettingCompetencySelection.vue?vue&type=template&id=57daf29b&"
import script from "./GJgrowEventCreateQuestionSettingCompetencySelection.vue?vue&type=script&lang=ts&"
export * from "./GJgrowEventCreateQuestionSettingCompetencySelection.vue?vue&type=script&lang=ts&"
import style0 from "./GJgrowEventCreateQuestionSettingCompetencySelection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports